export default __webpack_public_path__ + "static/media/brain-icon.e95a4add.svg";